firebird.controller('dialInInformationCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    'attendeeService',
    'socketService',
    'meetingService',
    'logService',
    'phoneConferenceService',
    'helperService',
    'connectivityService',
    'vertoService',
    'avDeviceService',
    'automationService',
    'brandingService',
    'localizationService',
    'subscriptionService',
    'userPairStateService',
    'modalHelperService',
    function (
        $window,
        $rootScope,
        $scope,
        attendeeService,
        socketService,
        meetingService,
        logService,
        phoneConferenceService,
        helperService,
        connectivityService,
        vertoService,
        avDeviceService,
        automationService,
        brandingService,
        localizationService,
        subscriptionService,
        userPairStateService,
        modalHelperService
    ) {
        var self = this;
        const logger = logService.createLoggerWithSource('dialInInformationCtrl');

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;
        self.onPhoneInformation = onPhoneInformation;
        self.switchToMic = switchToMic;
        self.canSwitchToMic = canSwitchToMic;
        self.updateAccessCode = updateAccessCode;
        self.modalState = 'closed';
        self.phoneNumber = '';
        self.isDedicated = false;
        self.isSinglePIN = false;
        self.accessCode = '';
        self.getAudioPin = getAudioPin;
        self.showInternationalNumbers = showInternationalNumbers;
        self.hasInternationalCalling = meetingService.hasFeature('internationalCalling');
        self.onPhonePairingStateUpdated = onPhonePairingStateUpdated;
        self.getTelUrlFromPhoneAndPin = getTelUrlFromPhoneAndPin;
        self.isTelephonePaired = isTelephonePaired;
        self.showAlertForUnpairedSinglePinUnmuting = showAlertForUnpairedSinglePinUnmuting;

        //Switch-to-Mic
        self.getSwitchToMicText = getSwitchToMicText;
        self.getSwitchToMicTooltip = getSwitchToMicTooltip;

        self.modalsAvailable = false;
        self.rootSubscription = undefined;

        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);
        $scope.$on('phone-information', self.onPhoneInformation);
        $scope.$on('phone-pairing-state-updated', self.onPhonePairingStateUpdated);
        $scope.$on('promoted-to-presenter', self.updateAccessCode);
        $scope.$on('demoted-to-attendee', self.updateAccessCode);

        init();

        ////////////////////////

        function init() {
            var info = phoneConferenceService.getPhoneData();
            if (!info || !Object.keys(info).length) {
                return;
            }
            self.phoneNumber = info.phoneNumberFree || info.phoneNumberToll;
            self.isDedicated = info.isDedicated;
            self.isSinglePIN = info.isSinglePIN;
            self.accessCode = attendeeService.getIsPresenter() ? info.presenterPIN : info.attendeePIN;

            self.rootSubscription = subscriptionService.createSubscription();
            self.rootSubscription.add(
                userPairStateService.modalsAvailable$.subscribe(next => {
                    self.modalsAvailable = next;
                })
            );
        }

        function getAudioPin() {
            return attendeeService.getAudioPin();
        }

        function showInternationalNumbers() {
            if (self.modalsAvailable) {
                modalHelperService.openInternationalNumbersModal(helperService.getLocationHost());
            } else {
                $rootScope.$broadcast('show-modal', 'internationalNumbers');
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('dialInInformation') !== -1) {
                if (helperService.getIsRedesign()) {
                    $rootScope.$broadcast('enable-header-auto-hide', { enable: true, reason: 'header-popover' });
                }
                self.modalState = 'closed';
                digest();
            }
        }

        function onShowModal(e, modalName) {
            if (modalName === 'dialInInformation') {
                self.modalState = 'open';
                digest();
            }
        }

        function onPhoneInformation(e, data) {
            if (!data || !Object.keys(data).length) {
                return;
            }

            self.phoneNumber = data.phoneNumberFree;
            self.accessCode = attendeeService.getIsPresenter() ? data.presenterPIN : data.attendeePIN;
        }

        function switchToMic() {
            logger.log('Dial-in information modal - Clicked switch-to-mic - Showing confirmation prompt');

            var title = localizationService.translate('HEADER.DIALOG.SWITCH_TO_MICROPHONE_QUESTION');
            var confirm = localizationService.translate('HEADER.DIALOG.SWITCH_TO_MICROPHONE');
            if (meetingService.isWebinarAttendee()) {
                title = localizationService.translate('DIAL_IN_INFORMATION.SWITCH_TO_COMPUTER_SPEAKERS.TITLE');
                confirm = localizationService.translate('COMMON.YES_TEXT');
            }
            $window.swal(
                {
                    title: title,
                    text: '',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: confirm,
                    cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                    closeOnConfirm: true
                },
                function (switchConfirmed) {
                    if (switchConfirmed) {
                        logger.log('Dial-in information modal - Confirmed switch-to-mic');
                        self.onHideModal({}, 'dialInInformation');
                        connectivityService.setAudioThroughPhone(false, true);
                    } else {
                        logger.log('Dial-in information modal - Cancelled switch-to-mic');
                    }
                }
            );
        }

        function canSwitchToMic() {
            var edgeServerEnabled = vertoService.isEdgeServerEnabled();

            if (connectivityService.getIsPhoneOnly()) {
                return false;
            }

            if (meetingService.isWebinar()) {
                if (attendeeService.getIsPresenter()) {
                    //Webinar Presenters can switch via Verto
                    return true;
                } else {
                    //Webinar Attendees can switch
                    //via Verto if edge server enabled
                    return edgeServerEnabled;
                }
            } else {
                if (helperService.browserHasWebRTC()) {
                    if (avDeviceService.hasMicrophone()) {
                        //WebRTC browsers in Meetings can switch via Verto
                        return true;
                    } else {
                        //Clients with no mic should not be able to switch to mic
                        return false;
                    }
                } else {
                    return false;
                }
            }
        }

        function getSwitchToMicText() {
            if (meetingService.isWebinarAttendee()) {
                return localizationService.translate('DIAL_IN_INFORMATION.SWITCH_TO_COMPUTER_AUDIO');
            } else {
                return localizationService.translate('DIAL_IN_INFORMATION.SWITCH_TO_MICROPHONE');
            }
        }

        function getSwitchToMicTooltip() {
            if (meetingService.isWebinarAttendee()) {
                return localizationService.translate(
                    'DIAL_IN_INFORMATION.CLICK_HERE_IF_YOU_PREFER_TO_USE_YOUR_COMPUTER_SPEAKERS_FOR_AUDIO'
                );
            } else {
                return localizationService.translate(
                    'DIAL_IN_INFORMATION.CLICK_HERE_IF_YOU_PREFER_TO_USE_YOUR_COMPUTER_MICROPHONE_FOR_AUDIO'
                );
            }
        }

        function updateAccessCode(e, data) {
            var phoneData = phoneConferenceService.getPhoneData();
            if (data) {
                phoneData.presenterPIN = data.presenterPIN;
            }

            self.accessCode = attendeeService.getIsPresenter() ? phoneData.presenterPIN : phoneData.attendeePIN;

            digest();
        }

        function getTelUrlFromPhoneAndPin() {
            var info = phoneConferenceService.getPhoneData();
            var phoneNumber = info.phoneNumberFree || info.phoneNumberToll;
            var pin = (attendeeService.getIsPresenter() ? info.presenterPIN : info.attendeePIN) + '#';
            return 'tel://' + phoneNumber.replace(/-/g, '') + ',,' + pin.replace(/ /g, '');
        }

        function onPhonePairingStateUpdated(e, data) {
            // digest to show updated text
            digest();

            if (data && data.phoneMemberId) {
                setTimeout(function () {
                    self.modalState = 'closed';

                    // digest to close dail-in modal
                    digest();
                }, 2500); // 2.5 seconds
            }
        }

        function isTelephonePaired() {
            return attendeeService.getIsPhonePaired();
        }

        function showAlertForUnpairedSinglePinUnmuting() {
            var securitySettings = meetingService.getMeetingSecuritySettings();
            return (
                self.isSinglePIN === true &&
                attendeeService.getIsHost() === true &&
                securitySettings.canUnmuteAudio === false &&
                securitySettings.ignoreCanUnmuteAudio === true
            );
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
